module.exports = __webpack_public_path__ + "img/alentour12.5bb8f732.jpg";